module.exports = __webpack_public_path__ + "img/acoustical PD localization at transformer 2.e2b998ca.jpg";